import * as React from "react";
import { Card, CardContent, Typography, CardActions, Button, Box, FormControl, MenuItem, FormControlLabel, Radio, InputLabel, Alert, } from "@mui/material";
import { Formik, FormikProps, Form, } from "formik";
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Link } from "react-router-dom";
import RadioGroup from '@mui/material/RadioGroup';
import Select from '@mui/material/Select';
import { useSelector } from "react-redux";
import { User } from "../../../types/user.type";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/store";
import { roleGetData, roleSelector } from "../../../store/slices/roleSlice";
import { userActionSelector, userCreateData } from "../../../store/slices/userActionSlice";
import Loader from "../../component/Loader";




type UserApiCreatePageProps = {
  //
};

const initialValues: User = { username: "", password: "", fullname: "", email: "", emailCC: "", isAd: false, roleId: null, active: true ,remark:"",approveLevel:1};


const UserApiCreatePage: React.FC<any> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const roleReducer = useSelector(roleSelector);
  const userActionReducer = useSelector(userActionSelector);
  const [password, setPassword] = React.useState<string>("");


  React.useEffect(() => {
    dispatch(roleGetData(""));
  }, [])


  const generatePassword = () => {
    const result = Math.random().toString(36).substring(2, 16);
    setPassword(result);

  }

  // const handleRoleChange = (event: SelectChangeEvent) => {
  //   setSelectRole(event.target.value as string);
  // };


  const showForm = ({ values, setFieldValue, isSubmitting, touched, errors, handleChange, handleBlur }: FormikProps<User>) => {
    return (
      <Form>
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography gutterBottom variant="h5">
              Create UserAPI
            </Typography>

            <TextField id="username"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('username')}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                errors.username && touched.username
                  ? errors.username
                  : ''
              }
              error={
                errors.username && touched.username
                  ? true
                  : false
              } />

            <div>
              <TextField id="password"
                style={{ marginTop: 16, width: '70%' }}
                variant="outlined"
                label={t('password')}
                onChange={handleChange}
                onBlur={handleBlur}
                value={password}
                helperText={
                  errors.password && touched.password
                    ? errors.password
                    : ''
                }
                error={
                  errors.password && touched.password
                    ? true
                    : false
                } />
              <Button variant="contained" color="warning" size="large"
                style={{ marginTop: 20, marginLeft: 15 ,width:'25%'}}
                onClick={() => generatePassword()}
              >

                {t('generatepassword')}
              </Button>
            </div>

            <TextField id="fullname"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('fullname')}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                errors.fullname && touched.fullname
                  ? errors.fullname
                  : ''
              }
              error={
                errors.fullname && touched.fullname
                  ? true
                  : false
              } />

            <TextField id="email"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('email')}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                errors.email && touched.email
                  ? errors.email
                  : ''
              }
              error={
                errors.email && touched.email
                  ? true
                  : false
              } />

<TextField id="emailCC"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('emailCC')}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                errors.emailCC && touched.emailCC
                  ? errors.emailCC
                  : ''
              }
              error={
                errors.emailCC && touched.emailCC
                  ? true
                  : false
              } />

            <FormControl style={{ marginTop: 16 }} fullWidth>
              <InputLabel htmlFor="roleId">{t('selectRole')}</InputLabel>
              <Select
                name="roleId"
                // value={roleReducer.result[0] && roleReducer.result[0].roleid}
                // defaultValue={roleReducer.result[0] && roleReducer.result[0].roleId}
                onChange={(event) => { setFieldValue('roleId', event.target.value) }}
                error={
                  errors.roleId && touched.roleId
                    ? true
                    : false
                }
              >
                {roleReducer.result.map((item, index) => (
                  <MenuItem key={item.roleId} value={item.roleId}>
                    {item.roleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField id="remark"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('remark')}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={''
              }
              error={
                errors.email && touched.email
                  ? true
                  : false
              } />

            <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
              <RadioGroup row name="active" onChange={(event) => { setFieldValue("active", event.currentTarget.value === "true" ? true : false) }} value={values.active}>
                <FormControlLabel control={<Radio />} value={true} label={t('active')} />
                <FormControlLabel control={<Radio />} value={false} label={t('inactive')} />
              </RadioGroup>
            </FormControl>

            {userActionReducer.isError && <Alert severity="error">{userActionReducer.message}</Alert>}

          </CardContent>
          <CardActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginRight: 1 }}
              disabled={userActionReducer.isFetching}
            >
              {t('btnCreate')}
            </Button>
            <Button component={Link} to="/user" variant="outlined" fullWidth>
              {t('btnCancel')}
            </Button>
          </CardActions>
        </Card>
      </Form>
    );
  };


  const inputRequired = t('inputRequired');
  const validationSchema = Yup.object().shape({
    username: Yup.string().required(inputRequired),
    fullname: Yup.string().required(inputRequired),
    email: Yup.string().email('Invalid email').required(inputRequired),
    roleId: Yup.string().required(inputRequired),
  });


  if (userActionReducer.isFetching) {
    return <><Loader /></>
  }


  return (
    <Box>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {

          const sendvalues = { ...values, password: password,approveLevel:1 }

          // console.log(sendvalues)
          dispatch(userCreateData(sendvalues));
          setSubmitting(false);
        }}
      >
        {(props: any) => showForm(props)}
      </Formik>
    </Box>
  );
};

export default UserApiCreatePage;
